import {objectFromEntries} from '@benchling/js-utils';

import {DataFrame} from 'data-frames/DataFrameTypes';
import {ColumnsMapping} from 'data-frames/util/AccessorUtils';
import {ColumnInfo} from 'insights/analytics-visualizations/viewers/prop-converters/PropConverterTypes';

export function getDataFrameColumnsMapping<TColumnsMapping extends ColumnsMapping<string>>(
  dataFrame: DataFrame,
  columnInfos: Array<ColumnInfo>
): TColumnsMapping {
  return objectFromEntries(
    columnInfos.map((columnInfo) => [columnInfo.chartDataColumnName, columnInfo.inputDataColumnSystemName])
  ) as TColumnsMapping;
}
